<template>
   <dashboard-layout>
      <v-container fluid class="down-top-padding py-0">
         <BaseBreadcrumb
            :title="page.title"
            :breadcrumbs="breadcrumbs"
         ></BaseBreadcrumb>
         <v-row>
            <v-col cols="12">
               <table-adm-payments></table-adm-payments>
            </v-col>
         </v-row>
      </v-container>
   </dashboard-layout>
</template>

<script>
import BaseBreadcrumb from '@/components/BaseBreadcrumb.vue'
import DashboardLayout from '@/Layouts/DashboardLayout.vue'
import TableAdmPayments from './Tables/TableAdmPayments.vue'

export default {
   name: "MOAPayments",
   components: {
      DashboardLayout,
      BaseBreadcrumb,
      TableAdmPayments,
   },
   data() {
      return {
         page: { title: "Membership Payments" },
         breadcrumbs: [
            { text: "Dashboard", disabled: false, to: "/dashboard" },
            { text: "Payments", disabled: true },
         ],
      }
   },
}
</script>
